import Play from '../../../public/svg_images/play.svg';

function PlaySvg() {
  return (
    <div style={{marginLeft:"26px",display:"flex",alignItems:"center",display:"block"}}>
    <Play
      width={18}
      height={21}
      aria-hidden="true" 
    />
    </div>
  );
}

export default PlaySvg;